export default __webpack_public_path__ + "static/media/16.decd736e.png";